import React, { useState } from 'react';
import { CreateNewsLetter } from '../../../Api/Api';
import { showToastErrorMsg, showToastSuccessMsg } from '../../../Store/toastMsg';

export default function Newsletter() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name.trim() || !email.trim()) {
            setError('Name and Email are required.');
            return;
        }

        // Make API call here with the form data
        const Payload = {
            emailId: email.toLowerCase(),
            fullName: name,
        };
        const response = await CreateNewsLetter(Payload);
        if (response && response.statusCode === 200) {
            showToastSuccessMsg(response.message);
            setName('');
            setEmail('');
            setError('');
        } else {
            showToastErrorMsg(
                response.message || response.error.response.data.message
            );
        }
    };

    return (
        <section className="dalmaf-home pt-4 pb-4" style={{ backgroundColor: 'var(--soft)', borderTop: '1px solid var(--line)', borderBottom: '1px solid var(--line)' }}>
            <div className="container" style={{ maxWidth: '840px', padding: '16px 20px' }}>
                <div className="text-center mb-4">
                    <h2 className="mb-2" style={{ color: 'var(--deep)', fontSize: 'clamp(24px, 3.5vw, 36px)', fontWeight: '800' }}>Subscribe to our <span style={{ color: 'var(--red)' }}>Newsletter</span></h2>
                    <p style={{ color: 'var(--muted)', fontSize: '16px', maxWidth: '500px', margin: '0 auto' }}>
                        Stay up to date with the latest legal updates, compliance changes, and business insights.
                    </p>
                </div>
                
                <form onSubmit={handleSubmit} className="text-center">
                    <div className="row justify-content-center g-3">
                        <div className="col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Your Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                style={{ minHeight: '48px', border: '1px solid transparent', borderRadius: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.06)', background: 'var(--white)', color: 'var(--ink)' }}
                            />
                        </div>
                        <div className="col-md-5">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Your Email Address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ minHeight: '48px', border: '1px solid transparent', borderRadius: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.06)', background: 'var(--white)', color: 'var(--ink)' }}
                            />
                        </div>
                        <div className="col-md-3">
                            <button
                                type="submit"
                                className="btn btn-primary w-100"
                                style={{ minHeight: '48px', borderRadius: '30px', fontSize: '15px' }}
                            >
                                Subscribe
                            </button>
                        </div>
                    </div>
                    {error && <div className="text-danger mt-3">{error}</div>}
                </form>
            </div>
        </section>
    );
}
